import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	background-color: #f5f5f5;
	padding-top: 20px;
`;

export const HeadingLowerFont = styled.p`
	margin: 0;
	text-align: center;
	font-size: 12px;
	color: #525252;
	margin-bottom: 35px;
	padding: 0 16px;
`;

export const HeadingFont = styled.p`
	margin: 0;
	text-align: center;
	line-height: 1.2;
	font-size: 22px;
	font-weight: 900;
	padding: 0 16px;
`;

export const ContentContainer = styled.div`
	width: 50%;
	margin: 0 auto;
	background-color: #fff;
	padding: 30px 60px;
	border-radius: 10px;
	font-size: 13px;
	ol li {
		font-size: 12px;
		line-height: 1.6;
		margin-bottom: 12px;
	}
	ol {
		margin-left: -26px;
	}
	ul {
		margin-top: -10px;
		margin-left: -20px;
		margin-bottom: 20px;
		list-style-type: disc;
	}
	ul li {
		margin: 0;
		line-height: 1.4;
	}
	@media screen and (max-width: 1000px) {
		width: 95%;
		padding: 30px;
	}
`;

export const BoldFont = styled.div`
	font-weight: 600;
`;
